module.exports = __webpack_public_path__ + "img/arrow-up-small-big.ac3e1ad9.svg";